import React, { useState, useEffect } from "react";
import { Container, ContainerDesktop } from "./styles";
import { useControles } from "../../context/controles.context";
import { PrimaryButton, PrimaryLabel, PrimaryTextInput, BackgroundWrapper } from "../../globalComponents";
import { Icon } from '@iconify/react';

import {useAuth} from '../../context/auth.context'
import { useNavigate } from "react-router-dom";
import { clearStoredAuthData, getStoredUser, mergeStoredUserProfile } from "../../utils/authStorage";

const CardPerfil = () => {
    const {isMobile, setSideBarStatus} = useControles()
    const [nome, setNome] = useState('')
    const [email, setEmail] = useState('')
    const {setAuthStatus, GetMe, setIsAdmin, ClearAdminAccessMode} = useAuth()
    const navigate = useNavigate()

    useEffect(()=>{
        setSideBarStatus(true)
        const user = getStoredUser()
        setNome(user?.name || user?.nome || '')
        setEmail(user?.email || '')

        const loadProfile = async () => {
            try {
                const response = await GetMe()
                const me = response?.data?.data || response?.data || {}

                setNome(me?.name || me?.nome || '')
                setEmail(me?.email || '')
                mergeStoredUserProfile(me)
            } catch (err) {
                console.log('Erro ao buscar perfil no /v1/auth/me:', err)
            }
        }

        loadProfile()
    }, [GetMe, setSideBarStatus])

    const SignOut = () => {
        localStorage.removeItem('@Email:BetBuilder')
        localStorage.removeItem('@Nome:BetBuilder')
        localStorage.removeItem('@Telefone:BetBuilder')
        sessionStorage.removeItem('@Token:BetBuilder')
        setAuthStatus(false)
        setIsAdmin(false)
        ClearAdminAccessMode()
        navigate('/')

        clearStoredAuthData()
        localStorage.removeItem('saldo')
        localStorage.removeItem('horarioLogin')
        
    }

    return (
        <>
            {isMobile ? 
                <>
                <Container className="container" style={{paddingBottom: 100}}>
                    <>
                    <div className="cardFundo">
                        <div className="first">
                            <h2>Meu Perfil</h2>
                            <div className="fotoPerfil">
                                <Icon icon="iconamoon:profile-fill" className="icon" />
                            </div>
                        </div>

                        <div className="form">
                            <div className="conjunto">
                                <PrimaryLabel>Nome</PrimaryLabel>
                                <PrimaryTextInput value={nome} disabled={true}/>
                            </div>
                            <div className="conjunto">
                                <PrimaryLabel>Email</PrimaryLabel>
                                <PrimaryTextInput value={email} disabled={true}/>
                            </div>

                            <div className="buttons" style={{gap: 4}}>
                                <PrimaryButton style={{width: '100%'}} onClick={SignOut}>
                                    Sair
                                </PrimaryButton>
                            </div>
                        </div>
                    </div>
                    </>
                </Container>
                <BackgroundWrapper>
                    <div className="bgImage">
                    </div>
                </BackgroundWrapper>
                </>
                :
                <>
                <ContainerDesktop className="container">
            <div className="cardFundo">
                <div className="first">
                    <h2>Meu Perfil</h2>
                    <div className="fotoPerfil">
                        <Icon icon="iconamoon:profile-fill" className="icon" />
                    </div>
                </div>

                <div className="form">
                    <div className="conjunto">
                        <PrimaryLabel>Nome</PrimaryLabel>
                        <PrimaryTextInput value={nome} disabled={true}/>
                    </div>
                    <div className="conjunto">
                        <PrimaryLabel>Email</PrimaryLabel>
                        <PrimaryTextInput value={email} disabled={true}/>
                    </div>

                    <div className="buttons" style={{gap: 4}}>
                        <PrimaryButton style={{width: '100%'}} onClick={SignOut}>
                            Sair
                        </PrimaryButton>
                    </div>
                </div>
            </div>
        </ContainerDesktop>
        <BackgroundWrapper>
            <div className="bgImage">
            </div>
        </BackgroundWrapper>
        </>
            } 

            
        </>

    )
}

export default CardPerfil